export default "__VITE_ASSET__DlfqQDBZ__"